
import { Component, Vue } from 'vue-property-decorator';
import api from '@/api';
import { Route } from 'vue-router';
import DateTimePicker from '@/components/DateTimePicker.vue';
import Util from '@/utils/util';
import imageConvert from '@/utils/image';
import Swal from 'sweetalert2';

const { pointVoucher, swapInPoint } = api;

interface swapInItemModel {
  itemId: number,
  itemName: string,
}

@Component({
  components: { DateTimePicker },
})
export default class SwapInPointVoucherAdd extends Vue {
  private loading: boolean = false;

  private valid: boolean = false;

  private isImport: boolean = false;

  private swapInItems: Array<swapInItemModel> = [];

  private statusSelect: Array<{ text: string, value: number}> = [
    { text: '未啟用', value: 0 },
    { text: '啟用', value: 1 },
  ];

  private form = {
    itemId: undefined,
    pointValue: 0,
    quantity: 0,
    expiryDate: '',
    status: 0,
    base64: undefined,
  }

  private get title() {
    return this.isImport ? '匯入' : '新增';
  }

  private setIsImport(status: boolean) {
    this.isImport = status;
  }

  private rules = {
    itemId: [this.requiredRule('兌換來源')],
    expiryDate: [this.requiredRule('到期日')],
    pointValue: [this.requiredRule('點數'), this.numberGreaterThenRule('點數', 0)],
    quantity: [this.requiredRule('數量'), this.numberGreaterThenRule('數量', 0)],
    base64: [this.validatefile((vm: SwapInPointVoucherAdd) => vm.form.base64)],
  }

  private requiredRule(column: string) {
    return (v: any) => !Util.isNullOrEmpty(v) || `${column} 為必填`;
  }

  private validatefile(func: (vm: SwapInPointVoucherAdd) => any) {
    return (v: any) => {
      const p = func(this);
      return !!v || !!p || '請上傳檔案';
    };
  }

  private numberGreaterThenRule(column: string, minNumber: number) {
    return (v: number) => v > minNumber || `${column}必須大於${minNumber}`;
  }

  private async setSwapInItems() {
    const { data: { data } } = await swapInPoint.itemList();
    this.swapInItems = data || [];
  }

  private async cancel() {
    await this.$router.back();
  }

  private async mounted() {
    await this.setSwapInItems();
  }

  private async submit() {
    const form = this.$refs.form as any as { validate: () => boolean };
    if (form.validate()) {
      if (this.isImport) {
        const data = {
          ...this.form,
          base64: await imageConvert(this.form.base64 as any),
        };
        const { status } = await pointVoucher.import(data);
        if (status === 1) {
          await Swal.fire({ icon: 'success', title: '匯入成功' });
          this.$router.back();
        }
      } else {
        const { status, data } = await pointVoucher.create(this.form);
        if (status === 1) {
          const item = this.swapInItems.find((p: swapInItemModel) => p.itemId === this.form.itemId);
          const fileName = `${item?.itemName}_quantity_${this.form.quantity}_point_${this.form.pointValue}.txt`;
          Util.saveFile(data, fileName);
          await Swal.fire({ icon: 'success', title: '新增成功' });
          this.$router.back();
        }
      }
    }
  }

  private async beforeRouteEnter(
    to: Route,
    from: Route,
    next: (to?: (vm: SwapInPointVoucherAdd) => void) => void,
  ) {
    const isImport = to.name === 'swapInPointVoucherImport';
    await next(async (vm) => {
      vm.setIsImport(isImport);
    });
  }
}
